import type { HealthResponse } from '@parinaam-vms/shared';
import { apiGet } from './client';

/**
 * Section 2.21. The frontend calls this so the Section 2.33 smoke test has a
 * visible answer: a developer sees the whole chain working in the browser rather
 * than reading three terminals.
 */
export function fetchHealth(): Promise<HealthResponse> {
  return apiGet<HealthResponse>('/health');
}
